import BaseService from './BaseService';

export default class SupeMoyaService extends BaseService {
    // Initializing important variables
    constructor() {
        super();
        this.path = 'supermoya';
    }

    emailConfirm(token) {
        return this.fetch(`${this.domain}/${this.path}/accounts/me/update/confirm/${token}`, {
            method: 'POST',
            body: JSON.stringify({token}),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    moyaPayEmailConfirm(token) {
        return this.fetch(`${this.domain}/${this.path}/accounts/moya-pay/confirm-billing-email/${token}`, {
            method: 'POST',
            body: JSON.stringify({token}),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    unsubscribe(token) {
        return this.fetch(`${this.domain}/${this.path}/accounts/me/update/confirm/${token}`, {
            method: 'POST',
            body: JSON.stringify({token}),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    settlementConfirm(token) {
        return this.fetch(`${this.domain}/${this.path}/accounts/me/update/confirm/${token}`, {
            method: 'POST',
            body: JSON.stringify({token}),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
}
